export const menuData = [
  {
    id: 1,
    feature_route: 'dashboard',
    display_name: 'Dashboard',
    feature_status: 'active',
    icon_name: 'dashboard',
  },
  {
    id: 2,
    feature_route: 'health-record',
    display_name: 'Health Records',
    feature_status: 'active',
    icon_name: 'health-record',
  },
  {
    id: 3,
    feature_route: 'calendar',
    display_name: 'Calendar',
    feature_status: 'active',
    icon_name: 'calendar',
  },
  {
    id: 4,
    feature_route: 'safehaven-careclub',
    display_name: 'CareClub+',
    feature_status: 'active',
    icon_name: 'careclub',
  },
  {
    id: 5,
    feature_route: 'journal',
    display_name: 'Journal',
    feature_status: 'active',
    icon_name: 'journal',
  },
  {
    id: 6,
    feature_route: 'health-vault',
    display_name: 'Document Center',
    feature_status: 'active',
    icon_name: 'document-center',
  },
  {
    id: 7,
    feature_route: 'insurance',
    display_name: 'Insurance',
    feature_status: 'active',
    icon_name: 'insurance',
  },
  {
    id: 8,
    feature_route: 'connection-hub',
    display_name: 'Connection Hub',
    feature_status: 'active',
    icon_name: 'connection-hub',
  },
]
